import script from "./TextInputHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInputHandler.vue?vue&type=script&setup=true&lang=js"

import "./TextInputHandler.vue?vue&type=style&index=0&id=c7ad5bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7ad5bd8"]])

export default __exports__